import React from 'react'
import { connect } from 'react-redux';
import { dispatch } from 'rxjs/internal/observable/pairs';
import { dataType } from '@/constants/data-type';
import DataTable from '@/components/DataTable/DataTable';
import { userActions } from '@/actions/user';
import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY, REFRESH_DATA } from '@/constants/app';
import { utilsFunction, Converter, Comparator } from "@/helpers/functions";
import { PARAMS as requestParams } from '@/constants/params';
import { getPortfolioAction } from '@/actions/trading';
import { openPlaceOrderDialog } from '@/actions/app';
import {WATCHLIST_FILTER_TYPE} from '@/constants/filter-type'
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';

class Watchlistfilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: null,
      portfolio: [{
        id: '1', title: 'portfolio_title', isActive: false
      }],
      columnDefs:[
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'symbol',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          minWidth: 100,
          cellRendererParams: {
            action:  this.toQuotePage.bind(this)
          },
          maxWidth:120
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'stockName',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          minWidth:260,
          maxWidth:350
        },
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'price',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          cellRendererParams: {
            action:  this.openPricePlaceorder.bind(this)
          },
          maxWidth:100
        },
        {
          headerName: props.language.common_change,
          colId: 'common_change',
          field: 'change',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          bindingColor: true,
          dataType: dataType.PERCENT_BASED,
          comparator: Comparator.numberComparator,
          minWidth:142,
          maxWidth:200
        },
        {
          headerName: props.language.common_bid,
          colId: 'common_bid',
          field: 'bid',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth:60,
          maxWidth:100
        },
        {
          headerName: props.language.common_ask,
          colId: 'common_ask',
          field: 'ask',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth:60,
          maxWidth:100
        },
        {
          headerName: props.language.common_volume,
          colId: 'common_volume',
          field: 'volume',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:190
        },
        {
          headerName: props.language.common_turnover_rate,
          colId: 'common_turnover_rate',
          field: 'turnoverRate',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.PERCENT_BASED,
          minWidth: 114,
          maxWidth:170  
        },
        {
          headerName: props.language.common_open,
          colId: 'common_open',
          field: 'open',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_high,
          colId: 'market_quote_high',
          field: 'high',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_low,
          colId: 'market_quote_low',
          field: 'low',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.common_turnover,
          colId: 'common_turnover',
          field: 'turnover',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 130,
          maxWidth:200
        },
        {
          headerName: props.language.common_market_value,
          colId: 'common_market_value',
          field: 'marketv',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 100,
          maxWidth:180
        },
        {
          headerName: props.language.common_float_cap,
          colId: 'common_float_cap',
          field: 'floatc',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_shares,
          colId: 'market_quote_shares',
          field: 'shares',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 130,
          maxWidth:200
        },
        // {
        //   headerName: props.language.market_quote_roe,
        //   colId: 'market_quote_roe',
        //   field: 'roe',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.NUMBER,
        //   comparator: Comparator.numberComparator
        // },
        // {
        //   headerName: props.language.market_quote_roa,
        //   colId: 'market_quote_roa',
        //   field: 'roa',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.NUMBER,
        //   comparator: Comparator.numberComparator
        // },
        {
          headerName: props.language.market_quote_ttm_eps,
          colId: 'market_quote_ttm_eps',
          field: 'ttmeps',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        }
      ],
      watchlist:{id: "00001", name: "長和", type: "S", market: "HKEX", weight: "1"}
    }
    if(props.innerRef){
      props.innerRef(this)
    }
  }

  componentDidMount() {
    const { currentTradingAccount, token ,isWatchList} = this.props
    // this.getWatchLists()
    this.toggleDeleteColumn()
  }

  componentDidUpdate(preProps) {
    const { userInfo, isNeedRefresh,language ,marketCode} = this.props;
    if (userInfo && preProps.userInfo !== userInfo) {
        this.getWatchLists(marketCode)
    }
    if (language && preProps.language !== language) {
      if(marketCode === ''){
        this.getPostion()
      }else{
        this.getWatchLists(marketCode)
      }
    }

    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      if(marketCode === ''){
        this.getPostion()
      }else{
        this.getWatchLists(marketCode)
      }
    }
    // if (marketCode && preProps.marketCode !== marketCode) {
    //     this.getWatchLists(marketCode)
    // }
  }

  // toQuotePage = (data) => {
  //   let stock = data.symbol
  //   let stockID = stock.substring(stock.indexOf(".") + 1).split('').findIndex(i => i !== '0')
  //   if (stockID > -1) {
  //     stockID = stock.substring(stock.indexOf(".") + 1).substr(stockID)
  //   }
  //   // if (this.props.marketParams.stockCode !== utilsFunction.instrumentIDZeroPadding(stockID)) {
  //     this.props.setStock({ stockCode: utilsFunction.instrumentIDZeroPadding(stockID), marketID: stock.substring(0, stock.indexOf(".")) }, () => {
  //       this.props.onClickSymbol()
  //     })
  //   // }
  // }

  getPostion = (callback) => {
    this.setState({ rowData: null })
    this.tableRef?.toggleLoadingOverlay(true);
    const { user, currentTradingAccount, language , mdsToken ,watchlist} = this.props
    const { clientID,tradingAccSeq } = currentTradingAccount
    const { id } = this.props.userInfo
    let portfoliodata = []
    let watchlistdata = []
    this.props.getWatchlist({ uuid: id }, res =>{
      if(res.result[1].flaggings){
        for(let i=0;i<res.result[1].flaggings.length;i++){
          let watchlistData = {
            marketID:res.result[1].flaggings[i].market, 
            stockCode: res.result[1].flaggings[i].id ,
            stockChineseShortName :res.result[1].flaggings[i].name,
            stockName :res.result[1].flaggings[i].name
          }
          watchlistdata.push(watchlistData)
         }
      } 
      const params = {
        [requestParams.CLIENT_ID]: clientID,
        [requestParams.TRADING_ACCOUNT_ID]: clientID,
        [requestParams.LANGUAGE]: language.lang,
        [requestParams.TRADING_ACC_SEQ]: tradingAccSeq
      }
      this.props.getAccountPortfolio(params, res => {
        for(let j = 0; j <  res.portfoliosList.length; j++){
          let portfoliosList = {marketID:res.portfoliosList[j].marketID, 
            stockCode: res.portfoliosList[j].stockCode ,
            stockChineseShortName :res.portfoliosList[j].stockChineseShortName,
            stockName :res.portfoliosList[j].stockName
          }
          portfoliodata.push(portfoliosList)
        } 
          let alldata = watchlistdata.concat(portfoliodata)
          let filtereddata = []
          for(let item1 of alldata){
            let flag = true
            for(let item2 of filtereddata){
              if(item1.marketID === item2.marketID && item1.stockCode=== item2.stockCode){
                flag = false
              }
            }
            if(flag == true){
              filtereddata.push(item1)
            }
          }
        if (Array.isArray(filtereddata) && filtereddata.length) {
          const lang = this.props.language.lang
          let filted = ''
          const sample = ['symbol', 'stockName', 'price', 'change','bid' , 'ask' , 'volume', 'turnoverRate', 'open', 'close', 'high', 'low',  'turnover' ,'marketv','floatc', 'shares', 'ttmeps'].reduce((prev, next) => (prev[next] = '-', prev), {})
          filted= filtereddata
          const rowData = []
          for (let i = 0; i < filted.length; i++) {
            const item = filted[i]
            const deepSample = JSON.parse(JSON.stringify(sample))
            deepSample.symbol = [item.marketID, item.stockCode].join('.')
            deepSample.marketv = item.marketValue
            if (lang === 'zh_TW' || lang === 'zh_CN') {
              deepSample.stockName = item.stockChineseShortName
              if(!item.stockChineseShortName){
                deepSample.stockName = item.stockName
              }
            } else {
              deepSample.stockName = item.stockName
            }
            let stockID = item.stockCode.split('').findIndex(i => i !== '0')
            if (stockID > -1) stockID = item.stockCode.substr(stockID)
            const marketID = Converter.mappingWebSocketMarket(item.marketID)
            // const dparams = { instrumentID: item.id, exchangeID: item.market }
            if (marketID === 'XNYS') {
              const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
              stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                const deepSample = oneNewRowData?.[i]
                if (deepSample) {
                  deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                  deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                  this.setState({ rowData: oneNewRowData })
                }
              })
              stockActions.getStatisticsAction(params, statisticsRes => {
                const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                const deepSample = twoNewRowData?.[i]
                if (deepSample) {
                  deepSample.price = statisticsRes.last
                  deepSample.open = statisticsRes.open
                  deepSample.high = statisticsRes.high
                  deepSample.low = statisticsRes.low
                  deepSample.volume = statisticsRes.volume
                  deepSample.turnover = statisticsRes.turnover
                  stockActions.getClosingPriceAction(params, closingPriceRes => {
                    const threeNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                    const deepSample = threeNewRowData?.[i]
                    if (deepSample) {
                      deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                      this.setState({ rowData: threeNewRowData })
                    }
                  })
                  this.setState({ rowData: twoNewRowData })
                }
              })
            } else {
              const dparams = {
                symbols: [
                  {
                    exchangeID: marketID,
                    key: stockID
                  }
                ],
                sessID:mdsToken
              }
              const params = {
                msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
                symbol: { exchangeID: marketID, key: stockID },
                language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
              }
              
              this.props.getFinancial(params, financialres => {
                if (financialres && Object.keys(financialres).length) {
                  const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  if(oneNewRowData){
                    const deepSample = oneNewRowData[i]
                    if (deepSample) {
                      Object.assign(deepSample, { shares: financialres.totalCapital ,ttmeps:financialres.earnps })
                      this.props.getDetailPriceInfo(dparams, quetores => {
                        if (quetores && Object.keys(quetores).length) {
                          const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                          const deepSample = twoNewRowData[i]
      
                          deepSample.price = quetores.last
                          deepSample.bid = quetores.bids?.[0]?.price
                          deepSample.ask = quetores.asks?.[0]?.price
                          deepSample.turnoverRate = quetores.turnoverRate ? utilsFunction.formatPercent(quetores.turnoverRate) : '-'
                          deepSample.open = quetores.open
                          deepSample.high = quetores.high
                          deepSample.low = quetores.low
                          deepSample.volume = quetores.vol
                          deepSample.close = quetores.prev
                          deepSample.turnover = quetores.turnover
                          deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                          deepSample.floatc = quetores.last * financialres.circCapital
                          // if (lang === 'zh_TW') {
                          //   deepSample.stockName = quetores.tcName
                          // } else if (lang === 'zh_CN') {
                          //   deepSample.stockName = quetores.scName
                          // } else {
                          //   deepSample.stockName = quetores.name
                          // }
                          this.setState({ rowData: twoNewRowData })
                        }
                      })
                      this.setState({ rowData: oneNewRowData })
                    }
                  }
                }
              })
            }

            rowData.push(deepSample)
          }
          this.setState({ rowData })
        }
        typeof callback === 'function' && callback()
        this.tableRef.toggleLoadingOverlay(false)
      })
    })
  } 
  
  getWatchLists(market = 'ALL',callback) {
    this.tableRef.toggleLoadingOverlay(true)
    const { id } = this.props.userInfo
    this.setState({ rowData: null })
    let watchlistdata = []
    this.props.getWatchlist({ uuid: id }, res => {
      if (Array.isArray(res.result) && res.result.length) {
        const lang = this.props.language.lang
        let filted = ''
        const sample = ['symbol', 'stockName', 'price', 'change', 'bid', 'ask', 'volume', 'turnoverRate', 'open', 'close', 'high', 'low', 'turnover', 'marketv', 'floatc', 'shares', 'ttmeps'].reduce((prev, next) => (prev[next] = '-', prev), {})
        const filtedData = res.result
        if (market === 'HKEX') {
          filted = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.HK)[0].flaggings
        } else if(market === 'USEX'){
          filted  = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.US)[0].flaggings
        } else if(market === 'CN'){
          filted  = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.StockConnect)[0].flaggings
        } else {
          filtedData.map((item)=>{
            market === item.name? filted = item.flaggings :''
          })
        }
        if (filted) {
          for (let i = 0; i < filted.length; i++) {
            let watchlistData = {
              marketID: filted[i].market,
              stockCode: filted[i].id,
              stockChineseShortName: filted[i].name,
              stockName: filted[i].name
            }
            watchlistdata.push(watchlistData)
          }
        }
        const rowData = []
        for (let i = 0; i < watchlistdata.length; i++) {
          const item = watchlistdata[i]
          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.symbol = [item.marketID, item.stockCode].join('.')
          let stockID = item.stockCode.split('').findIndex(i => i !== '0')
          if (stockID > -1) stockID = item.stockCode.substr(stockID)
          const marketID = Converter.mappingWebSocketMarket(item.marketID)
          if (lang === 'zh_TW' || lang === 'zh_CN') {
            deepSample.stockName = item.stockChineseShortName
            if(!item.stockChineseShortName){
              deepSample.stockName = item.stockName
            }
          } else {
            deepSample.stockName = item.stockName
          }
          // const dparams = { instrumentID: item.id, exchangeID: item.market }
          if (marketID === 'XNYS') {
            const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
            stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
              const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = oneNewRowData?.[i]
              if (deepSample) {
                deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                this.setState({ rowData: oneNewRowData })
              }
            })
            stockActions.getStatisticsAction(params, statisticsRes => {
              const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = twoNewRowData?.[i]
              if (deepSample) {
                deepSample.price = statisticsRes.last
                deepSample.open = statisticsRes.open
                deepSample.high = statisticsRes.high
                deepSample.low = statisticsRes.low
                deepSample.volume = statisticsRes.volume
                deepSample.turnover = statisticsRes.turnover
                stockActions.getClosingPriceAction(params, closingPriceRes => {
                  const threeNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  const deepSample = threeNewRowData?.[i]
                  if (deepSample) {
                    deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                    this.setState({ rowData: threeNewRowData })
                  }
                })
                this.setState({ rowData: twoNewRowData })
              }
            })
          } else {
            const dparams = {
              symbols: [
                {
                  exchangeID: marketID,
                  key: stockID
                }
              ],
              sessID: this.props.mdsToken
            }
            const params = {
              msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
              symbol: { exchangeID: marketID, key: stockID },
              language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
            }
    
            this.props.getFinancial(params, financialres => {
              if (financialres && Object.keys(financialres).length) {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                if(oneNewRowData){
                  const deepSample = oneNewRowData[i]
                  if (deepSample) {
                    Object?.assign(deepSample, { shares: financialres.totalCapital, marketv: financialres.marketCap, ttmeps: financialres.earnps })
                    this.props.getDetailPriceInfo(dparams, quetores => {
                      if (quetores && Object.keys(quetores).length) {
                        const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                        const deepSample = twoNewRowData[i]
      
                        deepSample.price = quetores.last
                        deepSample.bid = quetores.bids?.[0]?.price
                        deepSample.ask = quetores.asks?.[0]?.price
                        deepSample.turnoverRate = quetores.turnoverRate ? quetores.turnoverRate : '-'
                        deepSample.open = quetores.open
                        deepSample.high = quetores.high
                        deepSample.low = quetores.low
                        deepSample.volume = quetores.vol
                        deepSample.close = quetores.prev
                        deepSample.turnover = quetores.turnover
                        deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                        deepSample.floatc = quetores.last * financialres.circCapital
                        // if (lang === 'zh_TW') {
                        //   deepSample.stockName = quetores.tcName
                        // } else if (lang === 'zh_CN') {
                        //   deepSample.stockName = quetores.scName
                        // } else {
                        //   deepSample.stockName = quetores.name
                        // }
                        this.setState({ rowData: twoNewRowData })
                      }
                    })
      
                    this.setState({ rowData: oneNewRowData })
                  }
                }
              }
            })
          }
          rowData.push(deepSample)
        }
        this.setState({ rowData })
      }
      typeof callback === 'function' && callback()
      this.tableRef.toggleLoadingOverlay(false)
    })  
  }


  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  toggleDeleteColumn = (isOpen) => {
    const columnDefs = this.getWatchlistColumnDef(isOpen)
    // this.setState({ columnDefs })
    // this.tableRef.setColumnDefs(columnDefs)
    this.tableRef.renderColumnDefs(columnDefs)
  }

  getWatchlistColumnDef = (isOpenDeleteCol = false) => {
    const { columnDefs } = this.state
    const removeIconCol = [
      {
        headerName: '',//选择列头部显示的文字，可以为空
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: false,
        headerClass: 'selection-checkbox-header-center',
        cellClass: 'selection-checkbox-cell-center',
        'pinned': 'left', //固定再左边
        maxWidth: 40 ,//列的宽度,
        hide:!isOpenDeleteCol,
        cellRendererParams: {
          checkbox: this.toQuotePages
        }
    }]
    // }
    // if(isOpenDeleteCol){
    //   columnDefs.splice(0,2)
    // }
    // const standardCols = PRICE_BOARD_COLUMN_DEF.getColDef(this.props.language, {
    //   handleClickSymbol: this.props.onClickSymbol,
    //   handleDblClickPrice: this.handleOpenPlaceOrder,
    // })
    // return [...removeIconCol]
    if(isOpenDeleteCol){
      return [...removeIconCol,...columnDefs]
    }else{
      return [...columnDefs]
    }
  }
  toQuotePages = (data) => {
    // }
  }
  openPricePlaceorder=(data)=>{
    const datalist = {
      marketID: data.symbol.split('.')[0],
      instrumentID:data.symbol.split('.')[1],
      price : data.price,
      quantity : data.quantity || "0",
    }
    this.props.setPlaceOrderParams(datalist)
    // openPlaceOrderDialog(null,datalist,true)
  }

  toQuotePage = (data) => {
    this.props.toQuotePage(data)
  }
  getSelectionChanged=(data)=>{
    const{getSelectionChange} = this.props
    this.setState({
      selectionData:data
    })
    getSelectionChange(this.state.selectionData)
  }
  render() {
    const { rowData, columnDefs } = this.state;
    const { language, autoSize , marketCode} = this.props;
    return (
      <div className="watchlist-container" style={{ flexGrow: 1 ,height:'100%'}}>
         <DataTable
         name={TABLE_CONFIGURABLE_KEYS.TRADE_WATCHLIST_ALL}
         innerRef={e => this.tableRef = e}
         columnDefs={columnDefs}
         autoSizeColumns={autoSize}
         data={rowData} autoSizeColumns={true} />
      </div>
    )
  }

}

Watchlistfilter.defaultProps = {
  isFilter: false,
  autoSize: true
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    marketParams: state.trade.marketParams,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    mdsToken: state.trade.mdsToken,
    user: state.auth.user,
    watchlist :state.user.watchlist
  }),
  dispatch => ({
    getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    toggleRefreshMarket: (p) => dispatch({
      type: REFRESH_DATA.MARKET_ACTION,
      value: p
    }),
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    setPlaceOrderParams: (p) => dispatch(stockActions.setPlaceOrderParamsAction(p))
  })
)(Watchlistfilter)
